import PropTypes from 'prop-types';
import React from 'react';

import {
  CITY_FIELD_V2,
  COUNTRY_FIELD_V2,
  FIRST_NAME_FIELD_V2,
  LAST_NAME_FIELD_V2,
  STATE_FIELD_V2,
  STREET_FIELD_V2,
  ZIP_CODE_FIELD_V2,
} from '@glass/web/modules/resumes/fieldKeys';

import FormTextField from '@glass/shared/components/Form/FormTextField';

const firstNameInputProps = {
  name: 'fname',
  autoComplete: 'given-name',
};

export const FirstNameField = React.memo(({ autoFocus }) => (
  <FormTextField
    required
    autoFocus={autoFocus}
    inputProps={firstNameInputProps}
    name={FIRST_NAME_FIELD_V2}
  />
));

FirstNameField.propTypes = {
  autoFocus: PropTypes.bool,
};

FirstNameField.defaultProps = {
  autoFocus: false,
};

const lastNameInputProps = {
  name: 'lname',
  autoComplete: 'family-name',
};

export const LastNameField = React.memo(() => (
  <FormTextField inputProps={lastNameInputProps} name={LAST_NAME_FIELD_V2} />
));

const streetInputProps = {
  name: 'address',
  autoComplete: 'street-address',
};

export const StreetField = React.memo(() => (
  <FormTextField
    inputProps={streetInputProps}
    label="Street Address"
    name={STREET_FIELD_V2}
    placeholder="234 Sesame Street"
  />
));

const cityInputProps = {
  name: 'city',
  autoComplete: 'address-level2',
};

export const CityField = React.memo(() => (
  <FormTextField
    inputProps={cityInputProps}
    label="City"
    name={CITY_FIELD_V2}
    placeholder="Houston"
  />
));

const stateInputProps = {
  name: 'state',
  autoComplete: 'address-level1',
};

export const StateField = React.memo(() => (
  <FormTextField
    inputProps={stateInputProps}
    label="State"
    name={STATE_FIELD_V2}
    placeholder="Texas"
  />
));

const zipInputProps = {
  name: 'zip',
  autoComplete: 'postal-code',
};

export const ZipCodeField = React.memo(() => (
  <FormTextField
    inputProps={zipInputProps}
    label="Zip Code"
    name={ZIP_CODE_FIELD_V2}
    pattern="[0-9]*"
    placeholder="77059"
    type="tel"
  />
));

const countryInputProps = {
  name: 'country',
  autoComplete: 'country',
};

export const CountryField = React.memo(() => (
  <FormTextField
    inputProps={countryInputProps}
    label="Country"
    name={COUNTRY_FIELD_V2}
    placeholder="United States"
  />
));
